import React from 'react';
import translateService from '../common/translateService';
import common from '../common/common';

const NoContent = ({ virtualdir }) => {
  const message = translateService.get(`common.notFoundHeader`);
  const rootUrl = common.getSiteUrl(virtualdir);
  return (
    <div>
      <section className='section not-found'>
        <header className='section__header'>
          <h1 className='section__title text-center'>{message}</h1>
        </header>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
          }}>
          <img
            src={`${rootUrl}/content/img/icons_notfound.svg`}
            alt='404 not found'
            width='20%'
          />
        </div>
      </section>
    </div>
  );
};

export default NoContent;
